import { render } from "./FormElements.vue?vue&type=template&id=b70e41d6"
import script from "./FormElements.vue?vue&type=script&lang=js"
export * from "./FormElements.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormElements.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b70e41d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b70e41d6', __exports__)) {
    console.log('reload')
    api.reload('b70e41d6', __exports__)
  }
  
  module.hot.accept("./FormElements.vue?vue&type=template&id=b70e41d6", () => {
    console.log('re-render')
    api.rerender('b70e41d6', render)
  })

}


export default __exports__